import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png'
});

function FlyToVenue({ position }) {
  const map = useMap();
  map.flyTo(position, 15);
  return null;
}

export default function EventMap({ venues, height = '500px' }) {
  const center = [venues[0].lat, venues[0].lng];
  const [selected, setSelected] = React.useState(center);

  return (
    <div style={{ height, width: '100%' }}>
      <MapContainer center={center} zoom={13} style={{ height: '100%' }}>
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {venues.map((venue) => (
          <Marker
            key={venue.id}
            position={[venue.lat, venue.lng]}
            eventHandlers={{
              click: () => setSelected([venue.lat, venue.lng])
            }}
          >
            <Popup>
              <strong>{venue.name}</strong>
              <br />
              <button
                onClick={() =>
                  window.open(
                    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      venue.address
                    )}`
                  )
                }
              >
                Directions
              </button>
            </Popup>
          </Marker>
        ))}

        <FlyToVenue position={selected} />
      </MapContainer>
    </div>
  );
}
